import axios from 'axios';

const API_URL = 'https://api.tispot971.com/api';
export const API_BASE_URL = 'https://api.tispot971.com';
const API_TOKEN = '33757dce3880428148b844afb3d223b127c61b69afe917e8867c01d0116e9d42bc8cd4773ba05e8e4e112f3f7713266ce113e8fe9b8704dbe8ca4d709ea0b4c486a0b0402eb3a94df1908deeb2a1bf701b0512f895ca0e35ab87ef53578f8137140e95314418900089668677ddc34c9696be7cbcb008cc3e7544be6082fcaafd';
export const IOS_URL = 'https://apps.apple.com/us/app/tispot-971/id6742041307';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.karibtech.tispot';

const createApi = (customToken = null) => {
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${customToken || API_TOKEN}`
    },
  });
};

export const api = createApi();
export const createCustomApi = createApi;

export default api;